import styled from "styled-components";

export const StyledVisibilidadeModal = styled.section`
    .card {
        boder: 1px solid #ddd;
        border-radius: 4px;
        padding: 10px;
        margin: 2.5px 0;
        width: 100;

         .title-card {
            font-size: 1rem;
            font-weight: bold;
            margin-bottom: 10px;
            color: #999;
            position: absolute;
            background-color: #fff;
            padding: 0 5px;
            transform: translateY(-100%);

        }
    }

     .card-sub {
        border: 0.5px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        margin: 5px 8px;
    }

    .card-sub-status {
        border: 0.5px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        margin: 5px 5;
    }

    .title-card-sub {
            font-size: 1rem;
            font-weight: bold;
            margin-bottom: 10px;
            color: #999;
    }


  .default-button-red-medium {
    height: 40px;
    cursor: pointer;
    border: solid 1px #EE4B21;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.default-button-red-small {
    cursor: pointer;
    border: solid 1px #EE4B21;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.btn-encerrar{
    color: #FFF;
    font-size: 0.9rem;
    cursor: pointer;
    font-weight: 600;
    background-color: #aa0505;
    border-color: #b5aeae;
     &:hover {
        background-color: #7d0808;
        border: solid 1px #b5aeae;
    }
    &:disabled {
        cursor: not-allowed;
    }    
}

.btn-reabrir{
    color: #FFF;
    font-size: 0.9rem;
    cursor: pointer;
    font-weight: 600;
    background-color: #2c3b82;
    border-color: #b5aeae;
     &:hover {
        background-color: #232f67;
        border: solid 1px #b5aeae;
    }
    &:disabled {
        cursor: not-allowed;
    }    
}

.btn-primary{
    background-color: #EE4B21;
    border-color: #EE4B21;
     &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.btn-secondary {
    background-color: #b2b2b2;
    border-color: #c7c7c7;
     &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

table {
    font-size: 0.8rem
}

.table-legend-info {
    font-size: 12px;
    text-align: center;
    font-weight: 1000;
}

.hover {
    &:hover {
        cursor: pointer;
    }
}

.table-data-info {
    font-size: 12px;
    text-align: center;
}

.table-data-info-warning {
    font-size: 12px;
    text-align: center;
    background-color: #fff3cd;
}

.table-data-info-canceled {
    font-size: 12px;
    text-align: center;
    // background-color: #FF7F7F;
}

.table-data-info-pro-bono {
    font-size: 12px;
    text-align: center;
    background: #cdeeff;
}

.table-width {
    width: 100%;
}

table.table-bordered{
    border:1px solid #E8E8E8;
    margin-top:20px;
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
  }
table.table-bordered > thead > tr > th{
    border:1px solid #E8E8E8;
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
}
table.table-bordered > tbody > tr > td{
    border:1px solid #E8E8E8;
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
}

.table-value {
    font-size: 12px;
    text-align: center;
    font-weight: 1000;
}

.table-nowrap {
    white-space: nowrap;
}


.table-button {
    font-size: 14px;
    text-align: center;
    font-weight: 1000;
    width: 30% !important;
    color: #E8E8E8;
}

.table-color-button {
    color: #EE4B21;
}

.size-icon-acoes {
    font-size: 16px;
    cursor: pointer;
}

thead > tr > th{
    font-size: 13px;
}

.table-scroll {
    overflow-y: hidden;
    width:100%;
    height:100%;
}

.primeiro-ativo {
    color: #6c757d;
    font-weight: bold;
}

.primeiro-ativo-wip {
    color: #5c6064;
    font-weight: bold;
}

.primeiro-reprovado {
    background: #ff626230;
}

@media only screen and (max-width: 769px) {
    .table-scroll {
        overflow-x: scroll;
    }

    .form-container-min {
        width: 100% !important;
    }


}

@media only screen and (min-width: 770px) {
    .table-scroll {
        overflow-y: scroll;
        overflow-x: hidden !important;
    }

        .table-container {
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            height: 550px;


            table {
                border-collapse: collapse;
                width: auto;
                table-layout: auto;
            }

            th,
            td {
            }

            th {
                background-color: #fff;
                position: sticky;
                top: 0;
            }
          }

}


@media only screen and (min-width: 1500px) {

    .fixed-width-200 {
        width: 200px !important;
        white-space: wrap;
    }


    .fixed-width-390 {
        width: 390px !important;
        white-space: wrap;
    }



    .fixed-width-180 {
        width: 180px !important;
        white-space: wrap;
    }



}
.fixed-width-95 {
    width: 95px !important;
    white-space: nowrap !important;
}

.desativado {
    opacity: 0.5;
    cursor: not-allowed;
}

`;
